import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Finalmente ho un anno intero di Educazione Civica pronto. Ho smesso di cercare materiali la domenica sera.',
  author: 'Docente Scuola Media'
}, {
  quote: 'Le attività sulla cittadinanza digitale sono piaciute moltissimo agli studenti. Materiale moderno e ben fatto.',
  author: 'Docente Scuola Superiore'
}, {
  quote: 'Ho smesso di improvvisare ogni settimana. La programmazione annuale inclusa vale da sola il prezzo del kit.',
  author: 'Docente Coordinatore'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-203">
      <div className="max-w-6xl mx-auto" data-id="element-204">
        <div className="text-center mb-16" data-id="element-205">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight mb-4" data-id="element-206">
            Cosa dicono i colleghi
          </h2>
          <p className="text-text-sec text-lg" data-id="element-207">
            Oltre 1.000 docenti hanno già rivoluzionato le loro lezioni.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-208">
          {testimonials.map((t, i) => <div key={i} className="bg-white rounded-3xl border border-border-light p-8 shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-209">
              <div className="flex gap-1 mb-6" data-id="element-210">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-secondary text-secondary" data-id="element-211" />)}
              </div>
              <p className="text-text-main text-lg leading-relaxed font-medium italic flex-1 mb-6" data-id="element-212">
                "{t.quote}"
              </p>
              <div className="pt-6 border-t border-border-light" data-id="element-213">
                <p className="text-text-sec font-bold text-sm uppercase tracking-wider" data-id="element-214">
                  {t.author}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}